/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAppointmentHourResponse } from './GetAppointmentHourResponse';
import {
    GetAppointmentHourResponseFromJSON,
    GetAppointmentHourResponseFromJSONTyped,
    GetAppointmentHourResponseToJSON,
    GetAppointmentHourResponseToJSONTyped,
} from './GetAppointmentHourResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetAppointmentHourResponse
 */
export interface PaginatedResultOfGetAppointmentHourResponse {
    /**
     * 
     * @type {Array<GetAppointmentHourResponse>}
     * @memberof PaginatedResultOfGetAppointmentHourResponse
     */
    items?: Array<GetAppointmentHourResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetAppointmentHourResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAppointmentHourResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAppointmentHourResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAppointmentHourResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAppointmentHourResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAppointmentHourResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetAppointmentHourResponse interface.
 */
export function instanceOfPaginatedResultOfGetAppointmentHourResponse(value: object): value is PaginatedResultOfGetAppointmentHourResponse {
    return true;
}

export function PaginatedResultOfGetAppointmentHourResponseFromJSON(json: any): PaginatedResultOfGetAppointmentHourResponse {
    return PaginatedResultOfGetAppointmentHourResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetAppointmentHourResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetAppointmentHourResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetAppointmentHourResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetAppointmentHourResponseToJSON(json: any): PaginatedResultOfGetAppointmentHourResponse {
    return PaginatedResultOfGetAppointmentHourResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetAppointmentHourResponseToJSONTyped(value?: PaginatedResultOfGetAppointmentHourResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetAppointmentHourResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

